/**
 * THE DISPLAY PILL (frame 56) — the phone band's one control (DESIGN.md rule 3), at the
 * band's right edge: `Display  Project ▸ Stage`, the label muted and the group path bold.
 * It REPLACES the phone Filter chip (maintainer, 2 Sep 2026): filters live inside the
 * Display sheet it opens. Reads the same words the print head and the detail's kept-view
 * note read (`describeGroups` — one derivation).
 */
import { describeGroups, type DisplayConfig, type EntityDisplaySpec } from './engine.js';

export function DisplayPill<Row>({
  spec,
  config,
  onOpen,
}: {
  spec: EntityDisplaySpec<Row>;
  config: DisplayConfig;
  onOpen: () => void;
}): JSX.Element {
  const groups = describeGroups(spec, config);
  const path = groups === '' ? 'Ungrouped' : groups;
  return (
    <button
      type="button"
      className="display-pill"
      aria-haspopup="dialog"
      aria-label={`Display: ${path}`}
      onClick={onOpen}
    >
      <span className="display-pill-box">
        <span className="display-pill-key">Display</span>
        <strong className="display-pill-path">{path}</strong>
      </span>
    </button>
  );
}
